require('./dataSetEditorHeader.tpl.html');
require('./dataSetEditorHeader.i18n.json');
require('./dataSetEditorHeaderController.js');
require('./dataSetActionRepository.js');
require('./dataSetActionsUtil.js');

const DataSetEditorHeaderComponent = {
    templateUrl: '/configuration/dataSetEditor/header/dataSetEditorHeader.tpl.html',
    controller: 'dataSetEditorHeaderController',
    bindings: {}
};

angular.module('ums')
    .component('uiDataSetEditorHeader', DataSetEditorHeaderComponent);
